module.exports = __webpack_public_path__ + "img/北京古树游览推荐-PC三级页面｜内容详情.9f4797a1.jpg";